import Actions from '../../odata/actions';

const actions = new Actions('brandingCode', 'brandingCodes');

export default actions;
